







































import Vue from 'vue'
import ModalFullScreen from '@/common/components/ModalFullScreen.vue'
import AddonOption from '@/product/components/addonOptions/AddonOption.vue'
import { AddonProduct } from '@/product/types'

export default Vue.extend({
  components: {
    ModalFullScreen,
    AddonOption
  },
  props: {
    addonProducts: {
      type: Array as () => AddonProduct[],
      default: () => []
    },
    selectedAddonProductId: {
      type: String || undefined,
      default: null
    },
    selectedAddonFirstOptionId: {
      type: String || undefined,
      default: undefined
    },
    outOfStockOptions: {
      type: Object as () => { [key: string]: string },
      required: true
    },
    showHighlightAddonProductSelection: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    selectingAddonProductId?: string
    selectingAddonFirstOptionId?: string
  } {
    return {
      selectingAddonProductId:  this.selectedAddonProductId,
      selectingAddonFirstOptionId: this.selectedAddonFirstOptionId
    }
  },
  methods: {
    onUpdateAddonProduct() {
      this.$emit('update', {
        selectedAddonProductId: this.selectingAddonProductId,
        selectedAddonFirstOptionId: this.selectingAddonFirstOptionId
      })
    }
  }
})
